import dayjs from "dayjs";
import moment from "moment";
import { WIDGET_URL } from "./constants";

export const getBase64EncodedString = (string) => {
  return btoa(string);
};

export function generateRandomString(length, type = "string") {
  let result = "";
  let characters = "";
  switch (type) {
    case "string":
      characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      break;
    case "number":
      characters = "0123456789";
      break;
    default:
      characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  }

  const charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function parseFirebaseDateTime(timestamp, type = "datetime") {
  if (!timestamp) timestamp = new Date();
  else timestamp = timestamp.toDate();
  const date = timestamp.toDateString();
  const time = `${
    (timestamp.getHours() < 10 ? "0" : "") + timestamp.getHours()
  }:${(timestamp.getMinutes() < 10 ? "0" : "") + timestamp.getMinutes()}`;
  const weekDay = date.toLocaleString("en-US", { weekday: "long" });
  if (type === "date") {
    return date;
  } else if (type === "time") {
    return time;
  } else if (type === "weekDay") {
    return weekDay;
  } else if (type === "datetime_object") {
    return timestamp;
  } else if (type === "datetime") {
    return `${date} ${time}`;
  } else {
    return `${date} ${time} ${weekDay}`;
  }
}

export const getPlatformIcon = (platform) => {
  switch (platform) {
    case "chrome":
      return <i className="fa-brands fa-chrome"></i>;
    case "chrome mobile":
      return <i className="fa-brands fa-chrome"></i>;
    case "firefox":
      return <i className="fa-brands fa-firefox"></i>;
    case "safari":
      return <i className="fa-brands fa-safari"></i>;
    case "Microsoft edge":
      return <i className="fa-brands fa-edge"></i>;
    case "edge":
      return <i className="fa-brands fa-edge"></i>;
    case "microsoft edge":
      return <i className="fa-brands fa-edge"></i>;
    case "opera":
      return <i className="fa-brands fa-opera"></i>;
    default:
      return "-";
  }
};

export function getOSIcon(os) {
  switch (os) {
    case "windows":
      return <i className="fa-brands fa-windows"></i>;
    case "linux":
      return <i className="fa-brands fa-linux"></i>;
    case "ubuntu":
      return <i className="fa-brands fa-linux"></i>;
    case "ios":
      return <i className="fa-brands fa-apple"></i>;
    case "os X":
      return <i className="fa-brands fa-apple"></i>;
    case "os x":
      return <i className="fa-brands fa-apple"></i>;
    case "android":
      return <i className="fa-brands fa-android"></i>;
    default:
      return "-";
  }
}

export function getDeviceIcon(device) {
  switch (device) {
    case "desktop":
      return <i className="fa-solid fa-laptop"></i>;
    case "mobile":
      return <i className="fa-solid fa-mobile"></i>;
    default:
      return "-";
  }
}

export function capitalize(string = "") {
  if (!string) return "";

  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function enumerateDaysBetweenDates(startDate, endDate, format) {
  let dates = [];

  let currDate = moment(startDate).startOf("day");
  let lastDate = moment(endDate).startOf("day");

  dates.push(currDate.clone().format(format));
  while (currDate.add(1, "days").diff(lastDate) < 0) {
    dates.push(currDate.clone().format(format));
  }
  dates.push(lastDate.clone().format(format));

  return dates;
}
export const generateCode = (widget) => {
  const scriptConfig = {
    isOpen: false,
    position: "right",
    websiteToken: getBase64EncodedString(widget.url),
    property: widget.propertyId,
    widget: widget.id,
  };

  return (
    "<script>\n" +
    "(function(d,t) {\n" +
    "const b='" +
    WIDGET_URL +
    "';\n" +
    "const g=d.createElement(t),s=d.getElementsByTagName(t)[0];\n" +
    "g.src=b;\n" +
    "g.defer = true;\n" +
    "g.async = true;\n" +
    "s.parentNode.insertBefore(g,s);\n" +
    "g.onload=function(){\n" +
    "window.$widget = " +
    JSON.stringify(scriptConfig) +
    ";\n" +
    "window.initChat();\n" +
    "};\n" +
    "})(document,'script')\n" +
    "</script>\n"
  );
};

export function sortByCreatedAt(data) {
  const sortedData = data?.sort((a, b) => {
    return b.createdAt - a.createdAt;
  });

  return sortedData;
}

export const splitFullName = (fullName) => {
  const nameArray = fullName.split(" ");
  if (nameArray.length > 1) {
    const lastName = nameArray.pop();
    const firstName = nameArray.join(" ");
    return { firstName, lastName };
  } else {
    return { firstName: fullName, lastName: "" };
  }
};

export const formatDistance = (startDate, endDate) => {
  const date1 = dayjs(startDate);
  const date2 = dayjs(endDate);
  const hoursDifference = date2.diff(date1, "hour", true); // Calculate difference in hours
  return hoursDifference;
};
